module.exports = __webpack_public_path__ + "img/taiyos3.865d5a3f.gif";